/* eslint-disable @nx/enforce-module-boundaries */
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ChildDto } from '@malirang/api-client';
import { Gender, Relationship } from '@malirang/common';
import {
  Button,
  Icon,
  LocalStorageService,
  ModalService,
} from '@malirang/front-share';
import { ChildStore } from 'apps/parent/src/app/stores/child.store';
import { UserStore } from 'apps/parent/src/app/stores/user.store';

@Component({
  selector: 'app-select-child',
  standalone: true,
  imports: [CommonModule, Icon, Button, RouterModule],
  templateUrl: './select-child.html',
})
export default class SelectChildComponent {
  readonly modalService = inject(ModalService);
  readonly childStore = inject(ChildStore);
  readonly localStorage = inject(LocalStorageService);

  user = inject(UserStore).user;
  Gender = Gender;
  Relationship = Relationship;

  /**
   * @name selectChild
   * @description 아동을 선택합니다.
   * @param {ChildDto} child
   * @param {Event} ev
   * @returns {Promise<void>}
   */
  async selectChild(child: ChildDto, ev?: Event): Promise<void> {
    ev?.stopPropagation();
    await this.childStore.setSelectedChild(child);

    setTimeout(() => {
      this.modalService.close(child);
    }, 300);
  }

  /**
   * @name close
   * @description 모달을 닫습니다.
   * @param {Event} ev
   * @returns {void}
   */
  close(ev?: Event): void {
    ev?.stopPropagation();
    this.modalService.close();
  }

  /**
   * @name moveToCreateChild
   * @description 페이지 이동
   * @param {string} routePath
   * @param {Event} ev
   * @returns {void}
   */
  moveToPage(routePath: string, ev?: Event): void {
    ev?.stopPropagation();
    ev?.preventDefault();
    this.modalService.close(routePath);
  }
}
